module.exports = __webpack_public_path__ + "img/icon_blogs_selected.17e462ee.svg";